/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import BackButton from "../../../components/BackButton";
import Card from "../../../components/Card";
import SubMenu from "../../../components/SubMenu";
import Layout from "../../../layout";
import CustomButton from "../../../components/CustomButton";
import Checked from "../../../assets/icons/Checked.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getSubscriptionsConfig,
  getMySubscriptions,
  getPendingPlacementFees,
  createSubscription,
} from "../../../redux/actions/subscriptionActions";
import { SectionLoader } from "../../../components/PageLoader";
import EmptyState from "../../../components/EmptyState";
import Pagination from "../../../components/Pagination";
import httpRequest from "../../../ajax";
import { getCurrencySymbol } from "../../../utils/helpers";
import { Divider } from "@material-ui/core";

const subMenuOptions = [
  ["Post-A-Job", "/subscriptions/post-job"],
  ["Placement Fee", "/subscriptions/placement-fee"],
  ["Recruiters", "/subscriptions/recruiters"],
  ["Active Subscriptions", "/subscriptions/active"],
  ["Invoice", "/subscriptions/invoice"],
];

const Subscriptions = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);
  const { availableSubsreiptions, pendingPlacementFees } = useSelector(
    ({ subscription }) => subscription
  );
  const { userData } = useSelector((state) => state.auth);

  const [recruiterSubscriptions, setRecruiterSubscriptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    setLoading(true);
    if (pathname.includes("placement-fee")) {
      Promise.resolve(getPendingPlacementFees(dispatch, currentPage)).then(() =>
        setLoading(false)
      );
    } else {
      Promise.resolve(
        getSubscriptionsConfig(dispatch),
        getMySubscriptions(dispatch)
      ).then(() => setLoading(false));
    }
    if (pathname.includes("invoice")) {
      setShowInvoiceModal(true);
    } else {
      setShowInvoiceModal(false);
    }
    const fetchInvoices = async () => {
      try {
        const response = await httpRequest("get", "/jobs/invoices");

        if (response?.data?.status && response?.data?.data?.invoices) {
          const transformed = response.data.data.invoices.map((item) => ({
            id: item.id,
            invoice_number: item.invoice_number,
            jobtitle: item.role_title,
            status: item.status.charAt(0).toUpperCase() + item.status.slice(1),
            payment_type:
              item.payment_type === "initial" ? "Part Payment" : "Full Payment",
          }));

          setInvoices(transformed);
        }
      } catch (error) {
        console.error("Failed to fetch invoices:", error);
      }
    };

    if (pathname.includes("invoice")) {
      fetchInvoices();
    }
  }, [dispatch, pathname, currentPage]);

  const handleSubscribe = (configId) => {
    const payload = {
      subscription_config_id: parseInt(configId),
      isPaymentFromWallet: 1,
      card_id: 0,
    };

    setLoading(true);

    Promise.resolve(createSubscription(dispatch, { ...payload })).then(() =>
      setLoading(false)
    );
  };

  const handleRowClick = (id) => {
    history.push(`/subscriptions/invoice/${id}`);
  };

  useEffect(() => {
    const jobArray = [];
    const recruiterArray = [];
    if (availableSubsreiptions && availableSubsreiptions[0]) {
      availableSubsreiptions.forEach((subscription) => {
        if (subscription.category === "Recruiter") {
          recruiterArray.push(subscription);
        } else {
          jobArray.push(subscription);
        }
      });

      setRecruiterSubscriptions(recruiterArray);
    }
  }, [availableSubsreiptions]);

  const handlePayNow = async (recruitment) => {
    try {
      setIsLoading(true);
      const response = await httpRequest("post", "/jobs/pay_placement_fee", {
        candidate_recruitment_id: recruitment.id,
      });

      if (response.data.success) {
        await getPendingPlacementFees(dispatch, currentPage);
      }
    } catch (error) {
      console.error("Payment error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const displaySection = () => {
    if (pathname.includes("invoice")) {
      return (
        <div className="m-3">
          <Card noPadding additionalClass="p-0 mb-4">
            <div className="d-flex align-items-center status-sent px-3 py-2 fw-bold">
              Invoices
            </div>
            <div>
              <table
                className=""
                style={{
                  width: "100%",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                }}
              >
                <thead className="" style={{ backgroundColor: "#f8f9fa" }}>
                  <tr style={{ borderBottom: "1px solid #E5E8EB" }}>
                    <th
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#121417",
                        textAlign: "left",
                        paddingLeft: "10px",
                      }}
                    >
                      Job Title
                    </th>
                    <th
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#121417",
                      }}
                    >
                      Invoice Number
                    </th>
                    <th
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#121417",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#121417",
                      }}
                    >
                      Invoice Type
                    </th>
                  </tr>
                </thead>
                <tbody className=" bg-white">
                  {invoices.map((invoice) => (
                    <tr
                      key={invoice.id}
                      onClick={() => handleRowClick(invoice.id)}
                      style={{ cursor: "pointer" }}
                    >
                      <td
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          color: "#121417",
                          textAlign: "left",
                          paddingLeft: "10px",
                          borderBottom: "1px solid #E5E8EB",
                        }}
                      >
                        {invoice.jobtitle}
                      </td>
                      <td
                        style={{
                          fontSize: "10px",
                          fontWeight: "500",
                          color: "#61758A",
                          textAlign: "left",
                          borderBottom: "1px solid #E5E8EB",
                        }}
                      >
                        {invoice.invoice_number}
                      </td>
                      <td
                        style={{
                          fontSize: "10px",
                          fontWeight: "500",
                          color: "#61758A",
                          textAlign: "left",
                          borderBottom: "1px solid #E5E8EB",
                        }}
                      >
                        {invoice.status}
                      </td>
                      <td
                        style={{
                          fontSize: "10px",
                          fontWeight: "500",
                          color: "#61758A",
                          textAlign: "left",
                          borderBottom: "1px solid #E5E8EB",
                        }}
                      >
                        {invoice.payment_type}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {invoices.length === 0 && <p>No invoices found.</p>}
            </div>
          </Card>
        </div>
      );
    }

    if (pathname.includes("active")) {
      return (
        <div className="">
          <EmptyState text="you have no active Subscriptions" />
          {/* <Card noPadding additionalClass="p-0 mb-4">
            <div className="d-flex align-items-center status-sent px-3 py-2">
                Post-A-Job (Annual)
            </div>
            <div className="px-4 bg-gray bottom-mid-radius py-3 d-flex justify-content-end">
                Expires 26 April 2024
            </div>
          </Card> */}
        </div>
      );
    } else if (pathname.includes("recruiters")) {
      return (
        <div className="m-3">
          {/* Commented till when we activate payments */}
          {/* {recruiterSubscriptions.map((sub) => (
            <Card key={sub.id} noPadding additionalClass="p-0 mb-4">
              <div className="bg-gray mid-radius p-2 d-flex justify-content-between align-items-center">
                <div className="mx-4 py-3">
                  {sub.name} ({sub.type})
                </div>
                <span className="w-25">
                  <CustomButton
                    additionalClass="p-3"
                    text={PAY ${sub.amount}}
                    backgroundColor="#3A6ED4"
                    color="#fff"
                  />
                </span>
              </div>
            </Card>
          ))} */}

          {recruiterSubscriptions.length > 1 && (
            <Card
              key={recruiterSubscriptions[0].id}
              noPadding
              additionalClass="p-0 mb-4 mt-4"
            >
              <div className="bg-gray mid-radius p-2 d-flex justify-content-between align-items-center">
                <div className="mx-4 py-3">
                  {recruiterSubscriptions[0].description}
                  {/* ({recruiterSubscriptions[0].type}) */}
                </div>
                <span className="w-25">
                  <CustomButton
                    additionalClass="p-3"
                    text={`PAY $${recruiterSubscriptions[0].amount}`}
                    backgroundColor="#3A6ED4"
                    color="#fff"
                    handleClick={() =>
                      handleSubscribe(recruiterSubscriptions[0].id)
                    }
                    loading={loading}
                  />
                </span>
              </div>
            </Card>
          )}

          <p className="d-flex mt-3">
            <img src={Checked} alt="checked" />
            You can only send requests to 2 recruiters per recruiter access. If
            a recruiter declines you get refunded{" "}
            {getCurrencySymbol(userData?.country)}99 back into your wallet.
          </p>
        </div>
      );
    } else if (pathname.includes("placement-fee")) {
      return (
        <div className="m-3">
          <Card noPadding additionalClass="p-0 mb-4">
            <div className="d-flex align-items-center status-sent px-3 py-2">
              Pending Placement Fees
            </div>
            <div className="bg-gray bottom-mid-radius px-4 py-3">
              <div className="d-flex flex-column gap-4">
                {pendingPlacementFees.results.map((recruitment) => (
                  <div key={recruitment.id} className="border-bottom pb-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h6 className="mb-2">{recruitment.applicant_name}</h6>
                        <p className="text-muted mb-1">
                          Position: {recruitment.position || "N/A"}
                        </p>
                        <p className="text-muted mb-1">
                          Organization: {recruitment.organisation || "N/A"}
                        </p>
                        <p className="text-muted mb-1">
                          Salary: {getCurrencySymbol(userData?.country)}
                          {parseFloat(recruitment.salary).toLocaleString()}
                        </p>
                        <p className="text-muted mb-1">
                          Placement Fee: {getCurrencySymbol(userData?.country)}
                          {parseFloat(
                            recruitment.placement_fee || 0
                          ).toLocaleString()}
                        </p>
                        <p className="text-muted mb-0">
                          Job Poster Balance:{" "}
                          {getCurrencySymbol(userData?.country)}
                          {parseFloat(
                            recruitment.job_poster_wallet_balance
                          ).toLocaleString()}
                        </p>
                      </div>
                      <div className="d-flex flex-column align-items-end">
                        <span className="badge bg-warning text-dark mb-2">
                          {recruitment.status.toUpperCase()}
                        </span>
                        {/* {recruitment.contract_url && (
                          <a
                            href={recruitment.contract_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-primary mb-2"
                          >
                            View Contract
                          </a>
                        )} */}
                        <CustomButton
                          additionalClass="p-3"
                          text={isLoading ? "Processing..." : "Pay Now"}
                          backgroundColor="#3A6ED4"
                          color="#fff"
                          handleClick={() => handlePayNow(recruitment)}
                          loading={isLoading}
                          disabled={
                            isLoading || recruitment.status !== "pending"
                          }
                        />
                      </div>
                    </div>
                  </div>
                ))}
                {pendingPlacementFees.results.length === 0 && (
                  <EmptyState text="No pending placement fees" />
                )}
              </div>
            </div>
          </Card>
          {pendingPlacementFees.total > pendingPlacementFees.per_page && (
            <Pagination
              currentPage={pendingPlacementFees.current_page}
              totalPages={Math.ceil(
                pendingPlacementFees.total / pendingPlacementFees.per_page
              )}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      );
    } else {
      return (
        <div className="m-3">
          <Card noPadding additionalClass="p-0 mb-4">
            <div className="d-flex align-items-center status-sent px-3 py-2">
              Free For now
            </div>
            <div className="bg-gray bottom-mid-radius px-4 py-3">
              Posting a job on the referral timeline is free for now
            </div>
          </Card>
          {/* {jobSubscriptions && jobSubscriptions[0] && (
            <>
              {jobSubscriptions.map((sub) => (
                <Card key={sub.id} noPadding additionalClass="p-0 mb-4">
                  <div className="d-flex align-items-center status-sent px-3 py-2">
                    {sub.name} ({sub.type})
                  </div>
                  <div className="bg-gray bottom-mid-radius px-4 py-3">
                    {<NewlineText text={sub.description} />}
                    <div className="d-flex justify-content-end">
                      <span className="d-none d-md-block w-25">
                        <CustomButton
                          additionalClass="p-3"
                          text={PAY ${sub.amount}}
                          backgroundColor="#3A6ED4"
                          color="#fff"
                        />
                      </span>
                      <span className="d-md-none w-75">
                        <CustomButton
                          additionalClass="p-3"
                          text={PAY ${sub.amount}}
                          backgroundColor="#3A6ED4"
                          color="#fff"
                        />
                      </span>
                    </div>
                  </div>
                </Card>
              ))}
            </>
          )} */}
        </div>
      );
    }
  };
  return (
    <Layout>
      <div className="position-relative d-flex flex-column flex-md-row mt-3">
        <div className="sub-menu-container">
          <BackButton />
          <SubMenu menuOptions={subMenuOptions} />
        </div>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center flex-grow-1 w-100">
            <SectionLoader />
          </div>
        ) : (
          <div className="main-content ml-md-4 flex-grow-1">
            <Card additionalClass="position-relative py-4 w-100">
              {displaySection()}
            </Card>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Subscriptions;
